import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import type { Category } from "../types";

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchCategories = async () => {
      try {
        const snap = await getDocs(
          query(collection(db, "categories"), orderBy("order", "asc")),
        );
        const list = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        })) as Category[];
        if (!cancelled) {
          setCategories(list.filter((c) => c.active !== false));
        }
      } catch {
        if (!cancelled) setCategories([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    fetchCategories();
    return () => {
      cancelled = true;
    };
  }, []);

  return { categories, isLoading };
};
